/**
 * @constructor
 * @implements {Foundation.Session.Manager.Delegate}
 */
Foundation.Google.SessionManagerDelegate = function () {}

Foundation.Google.SessionManagerDelegate.prototype.sessionManagerID = function () {
  return "google"
}

Foundation.Google.SessionManagerDelegate.prototype.logOut = function () {
  return Foundation.Google.cleanCookie()
}

Foundation.Google.SessionManagerDelegate.prototype.revalidateLogin = function () {
  // This hijacks creating a new Member
  // Foundation.Google.userSiteSignIn()
}

Foundation.Google.SessionManagerDelegate.prototype.observeExternalSessionEvents = function () {
  window["Foundation"]["Google"]["signInListening"] = true
}

Foundation.Google.SessionManagerDelegate.prototype.unobserveExternalSessionEvents = function () {
  window["Foundation"]["Google"]["signInListening"] = false
}

Foundation.Session.Manager.sharedInstance().registerDelegate(new Foundation.Google.SessionManagerDelegate())
